import { useEffect } from "react";
import { SurveyEngine_Models_BaseResponse, SurveyEngine_Models_SetLanguageResponse } from "../../../api";
import { useThemeKeyValues } from "../../../Hooks/useThemeKeyValues";
import { useGlobalCtx } from "../../../Context/GlobalContext";

interface SetLanguageProps {
    id: number,
    language:string
    callback: (response: SurveyEngine_Models_BaseResponse) => void
  }
  
  export const SetLanguage = (props: SetLanguageProps) => {

    const globalCTX = useGlobalCtx();
    const {getThemeKeyValueCommand} = useThemeKeyValues();
    
    useEffect(() => {
  
        if(props.language?.length > 0)
        {
            getThemeKeyValueCommand(globalCTX.Theme,props.language);
        }
        let response: SurveyEngine_Models_SetLanguageResponse = {
            commandType: "SetLanguage",
            commandIndex: props.id,
          };
          props.callback(response);
  
    }, [props,getThemeKeyValueCommand])
  
    return <></>
  }
  